import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../../firmwareAssignmentState/firmwareAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './FirmwareCrumb.module.scss';

const FirmwareCrumb: React.FC = () => {
	const { deleteFirmwareFromRestaurant, firmwares } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	return (
		<div className={style.container} data-test="FirmwareCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="firmwareLabel"
					size="s"
					weight="bold"
				/>
				{firmwares.map((restaurant, i) => {
					const isAnyFirmwareSelected = !!restaurant.firmwares.length;

					return (
						<div key={restaurant.restaurantId} data-test={`item-${i}`}>
							{isAnyFirmwareSelected && (
								<Text
									className={style.sectionName}
									translationKey={restaurant.restaurantAddress}
									size="xs"
									withTooltip={true}
								/>
							)}
							<div className={style.selectedItemWrapper}>
								{restaurant.firmwares.map((firmware) => {
									return (
										<SelectedItemForBreadcrumbs
											key={firmware.firmwareId}
											label={firmware.firmwareName || ''}
											onDelete={() =>
												deleteFirmwareFromRestaurant(
													restaurant.restaurantId,
													firmware.firmwareId,
												)
											}
										/>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default FirmwareCrumb;
